export default __webpack_public_path__ + "static/media/2_0104.d0a56ec0.webp";